<template>
  <div :class="[$style.flexContainer, $style.inputRow]">
    <div
      :class="$style.flexSingleWidth"
    >
      <InputValidator
        :config="config.attributeValue"
        data-test-id="IdmCustomRequiredAttributeField_attributeValue"
        @InputValidatorModel="listItem.attributeValue.changeHandler"
      />
    </div>
    <div
      :class="$style.flexSingleWidth"
    >
      <InputValidator
        :config="config.attribute"
        data-test-id="IdmCustomRequiredAttributeField_attribute"
      />
    </div>
  </div>
</template>

<script>
import { isJSONPath } from 'client/applications/utils/ApplicationUtils';
import InputValidator from 'client/components/FormValidation/InputValidator.vue';

export default {
  name: 'RequiredAttributeField',

  components: {
    InputValidator,
  },

  inject: ['$validator'],

  props: {
    listItem: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    config() {
      return {
        attributeValue: {
          ...this.listItem.attributeValue,
          ...{
            label: '',
            validate: {
              isJSONPath: true,
              required: true,
            },
          },
        },
        attribute: {
          ...this.listItem.attribute,
          ...{
            label: '',
            disabled: 'disabled',
          },
        },
      };
    },
  },

  beforeMount() {
    isJSONPath(this.$validator);
  },
};
</script>

<style module>
@import '../css/IdentityManagementCommon.css';

</style>
